import React from "react";
import { Box, Typography, Button, TextField } from "@mui/material";
import style from "./style";

const SubscriptionPage = ({
  limits,
  isSaving,
  onChange,
  onSave,
  isSaveDisabled,
}) => {
  return (
    <Box sx={{ ...style.container, width: "35%" }}>
      <Typography sx={style.header}>Subscription Settings</Typography>
      <Box sx={style.cardsWrapper}>
        <Box sx={style.card}>
          <Typography sx={style.fieldLabel}>
            Payroll Limit (Yearly)
          </Typography>
          <TextField
            type="number"
            size="small"
            inputProps={{ min: 1, max: 10000 }}
            value={limits.payslipLimit}
            onChange={(event) => onChange("payslipLimit", event.target.value)}
            placeholder="Enter payroll limit"
            sx={style.input}
          />
          <Typography sx={style.fieldLabel}>
            Employee Limit (Yearly)
          </Typography>
          <TextField
            type="number"
            size="small"
            inputProps={{ min: 1, max: 10000 }}
            value={limits.employeeLimit}
            onChange={(event) =>
              onChange("employeeLimit", event.target.value)
            }
            placeholder="Enter employee limit"
            sx={style.input}
          />
          <Button
            variant="contained"
            color="success"
            type="button"
            size="small"
            sx={style.primaryButton}
            onClick={onSave}
            disabled={isSaveDisabled}
          >
            {isSaving ? "Saving..." : "Save"}
          </Button>
        </Box>
      </Box>
    </Box>
  );
};

SubscriptionPage.defaultProps = {
  limits: { payslipLimit: "", employeeLimit: "" },
  isSaving: false,
  onChange: () => {},
  onSave: () => {},
  isSaveDisabled: true,
};

export default SubscriptionPage;

